export const HANDLE_USER = 'HANDLE_USER';
export const LOGOUT = 'LOGOUT';
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';